<template>
  <b-modal id="uploadDocumentModal" size="xl" hide-footer @hidden="resetData">
      <b-row slot="modal-header">
        <b-col>
          <h6>{{ $t('buttons.uploadDocument') }}</h6>
        </b-col>
      </b-row>
      <b-row>
      <b-col cols="12">
        <documentsToUploadCollection :attachToEmail="pathType !== 'api/user_datas/'" :document-type-options="documentTypeOptions" :documents-to-upload="documentsToUpload"/>
        <b-row class="mt-4">
          <b-col>
            <b-btn @click="submitFile()">{{ $t('buttons.submit') }}</b-btn>
            <button type="button" class="btn btn-warning" @click="clearFiles">{{ $t('buttons.clear') }}</button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import DocumentsToUploadCollection from '@/components/Dashboard/Views/excmdevicemodel/components/UploadDocumentModal/DocumentsToUploadCollection'

export default {
  name: 'UploadDocumentModal',
  components: {
    DocumentsToUploadCollection
  },
  props: {
    pathType: {}
  },
  computed: {
    show () {
      return this.$store.state.modals.uploadDocument.show
    },
    path () {
      return this.$store.state.modals.uploadDocument.path
    },
    close () {
      return this.$store.state.modals.uploadDocument.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'path': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      isLoading: false,
      documentsToUpload: [{
        title: '',
        document: null,
        uploadPercentage: 0,
        documentType: null,
        attachToEmail: 0,
        documents: []
      }],
      uriPath: null,
      documentTypeOptions: []
    }
  },
  created () {
    this.fetchDocumentTypeOptions()
  },
  methods: {
    clearFiles () {
      this.$refs['file-input'].reset()
    },
    openModal () {
      if (this.show === 1 && this.path) {
        this.uriPath = this.path.slice()
        this.$store.state.modals.uploadDocument.show = 0
        this.$store.state.modals.uploadDocument.path = null
        this.$bvModal.show('uploadDocumentModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.uploadDocument.close = 0
      }
      this.$bvModal.hide('uploadDocumentModal')
    },
    async uploadSingleFile (document) {
      let link = this.uriPath
      let formData = new FormData()
      formData.append('document', document.document)
      formData.append('title', document.title)
      formData.append('documentType', document.documentType)
      formData.append('attachToEmail', document.attachToEmail)
      await this.$http.post(link,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: function (progressEvent) {
            document.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
          }
        }
      ).then(async response => {
        if (response.status === 201) {
          await this.setDocumentType(response.data['@id'], document.documentType, document.attachToEmail)
        } else if (response.status === 207) {
          let text = ''
          for (let i in response.data) {
            text += response.data[i] + '\n'
          }
          this.$Swal({
            type: 'warning',
            title: text,
            timer: 2500
          })
        }
      }).catch(error => {
        if (error.response.status === 400) {
          let text = error.response.data['hydra:description']
          this.$Swal({
            type: 'warning',
            title: text,
            timer: 2500
          })
        }
        console.log(error)
      })
    },
    async submitFile () {
      this.isLoading = true
      for (let i in this.documentsToUpload) {
        await this.uploadSingleFile(this.documentsToUpload[i])
      }
      this.isLoading = false
      this.closeModal()
      this.$emit('input', 1)
    },
    async setDocumentType (documentId, documentTypeId, attachToEmail) {
      await new ApiService(`e_x_c_m_document_files/${getId(documentId)}`).putSilent({ idDocumentType: documentTypeId, attachToEmail: attachToEmail })
    },
    resetData () {
      this.uriPath = null
      this.documentsToUpload = [{
        document: null,
        uploadPercentage: 0,
        title: '',
        documentType: null,
        attachToEmail: 0
      }]
    },
    async fetchDocumentTypeOptions () {
      let params = { pagination: false }
      if (this.$route.name === 'EXCMCaseShow') {
        params.applicableForCase = getId(this.$route.params.id)
      }
      const response = await new ApiService('document_types', params).getResults()
      this.documentTypeOptions = response.items.map(type => {
        return {
          value: type['@id'],
          text: type.title,
          allowedExtensions: type.allowedExtensions
        }
      })
    }
  }
}
</script>
